module.exports = __webpack_public_path__ + "static/media/aroundb.89a1ecdb.png";